export const GitlabIconUrl = "https://gitlab.com/favicon.ico";
